import {
  TREQUEST_CUTBANK_OUT_ACTIVITY_LOG,
  TREQUEST_CUTBANK_OUT_TRANSACTION_LOG,
  TRESPONSE_CUTBANK_OUT_ACTIVITY_LOG,
  TRESPONSE_CUTBANK_OUT_TRANSACTION_LOG,
  TRESPONSE_GET_CUTBANK_SUBJECTS,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TCutbankOutActionType } from './cutbank-out-db.models';

export class GetSubjects implements Action {
  readonly type = TCutbankOutActionType.GetSubjectList;
  constructor() {}
}

export class GetSubjectsSuccess implements Action {
  readonly type = TCutbankOutActionType.GetSubjectListSuccess;
  constructor(public cutbankOutRes: TRESPONSE_GET_CUTBANK_SUBJECTS) {}
}

export class GetSubjectsFailure implements Action {
  readonly type = TCutbankOutActionType.GetSubjectListFailure;
  constructor() {}
}

export class GetTransactionLog implements Action {
  readonly type = TCutbankOutActionType.GetTransactionLog;
  constructor(public payload: TREQUEST_CUTBANK_OUT_TRANSACTION_LOG) {}
}

export class GetTransactionLogSuccess implements Action {
  readonly type = TCutbankOutActionType.GetTransactionLogSuccess;
  constructor(public transactionLog: TRESPONSE_CUTBANK_OUT_TRANSACTION_LOG) {}
}

export class GetTransactionLogFailure implements Action {
  readonly type = TCutbankOutActionType.GetTransactionLogFailure;
  constructor() {}
}

export class GetActivityLog implements Action {
  readonly type = TCutbankOutActionType.GetActivityLog;
  constructor(public payload: TREQUEST_CUTBANK_OUT_ACTIVITY_LOG) {}
}

export class GetActivityLogSuccess implements Action {
  readonly type = TCutbankOutActionType.GetActivityLogSuccess;
  constructor(public activityLog: TRESPONSE_CUTBANK_OUT_ACTIVITY_LOG) {}
}

export class GetActivityLogFailure implements Action {
  readonly type = TCutbankOutActionType.GetActivityLogFailure;
  constructor() {}
}

export class IsComponentBundleScanEnabled implements Action {
  readonly type = TCutbankOutActionType.IsComponentBundleScanEnabled;
  constructor() {}
}

export class IsComponentBundleScanEnabledSuccess implements Action {
  readonly type = TCutbankOutActionType.IsComponentBundleScanEnabledSuccess;
  constructor(public isComponentBundleScanEnabled: boolean) {}
}

export type TCutbankOutActions =
  | GetSubjects
  | GetSubjectsSuccess
  | GetSubjectsFailure
  | GetTransactionLog
  | GetTransactionLogSuccess
  | GetTransactionLogFailure
  | GetActivityLog
  | GetActivityLogSuccess
  | GetActivityLogFailure
  | IsComponentBundleScanEnabled
  | IsComponentBundleScanEnabledSuccess;
